<script setup lang="ts">
import { useDebounceFn } from '@vueuse/core'
import IconField from 'primevue/iconfield'
import InputIcon from 'primevue/inputicon'
import InputText from 'primevue/inputtext'

const model = defineModel<string>({ default: '' })

const commit = useDebounceFn((value: string | undefined) => {
  model.value = value ?? ''
}, 250)

function clearFilterText() {
  model.value = ''
}
</script>

<template>
  <div class="p-2">
    <IconField>
      <InputText :modelValue="model" @update:modelValue="commit" class="w-full" placeholder="Search" />
      <InputIcon class="pi pi-times cursor-pointer" @click="clearFilterText" />
    </IconField>
  </div>
</template>
